<script setup lang="ts" generic="T extends string | number">
import { FORM_CONTROL_CLASS } from './form-control';
import type { TSelectProps } from './t-select';

defineOptions({
  inheritAttrs: false,
});

const props = withDefaults(defineProps<TSelectProps<T>>(), {
  disabled: false,
  required: false,
});

const model = defineModel<T | undefined>();

const EMPTY_VALUE = '';

const selectValue = (): string => {
  if (model.value === undefined) {
    return EMPTY_VALUE;
  }

  return String(model.value);
};

const onChange = (event: Event): void => {
  const nextValue = (event.target as HTMLSelectElement).value;
  if (nextValue === EMPTY_VALUE) {
    model.value = undefined;
    return;
  }

  const matchedOption = props.options.find(
    (option) => String(option.value) === nextValue,
  );
  model.value = matchedOption?.value;
};
</script>

<template>
  <select
    v-bind="$attrs"
    :id="props.id"
    :class="FORM_CONTROL_CLASS"
    :value="selectValue()"
    :disabled="props.disabled"
    :required="props.required"
    @change="onChange"
  >
    <option
      v-if="props.placeholder !== undefined"
      :value="EMPTY_VALUE"
      :disabled="props.required"
    >
      {{ props.placeholder }}
    </option>
    <option
      v-for="option in props.options"
      :key="String(option.value)"
      :value="String(option.value)"
      :disabled="option.disabled"
    >
      {{ option.label }}
    </option>
  </select>
</template>
